export default __webpack_public_path__ + "static/media/relogio@3x.86c74e91.png";